const AFF = '/aff';
const DASHBOARD_HOME_ROUTE = '/dashboard';

export const DASHBOARD_ROUTES = {
  index: DASHBOARD_HOME_ROUTE,
  aff: AFF + DASHBOARD_HOME_ROUTE,
};
